/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AssignableUsers } from '../../models/assignable-users';
import { UserOverviewList } from '../../models/user-overview-list';

export interface ApiTicketAssignableUsersPost$Params {
      body: AssignableUsers
}

export function apiTicketAssignableUsersPost(http: HttpClient, rootUrl: string, params: ApiTicketAssignableUsersPost$Params, context?: HttpContext): Observable<StrictHttpResponse<UserOverviewList>> {
  const rb = new RequestBuilder(rootUrl, apiTicketAssignableUsersPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserOverviewList>;
    })
  );
}

apiTicketAssignableUsersPost.PATH = '/api/ticket/assignable-users';
